import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import ReplayIcon from "@mui/icons-material/Replay";
import { PaymentStatus } from "../../types/payments";

/**
 * Colour per transaction status. Labels live in the translation files under
 * `paymentStatus.*`, keyed by the raw status returned by the payments API.
 */
const statusColors: Record<PaymentStatus, string> = {
  pending: semanticColors.status.inProgress,
  payment_pending: semanticColors.status.inProgress,
  paid: semanticColors.status.completed,
  expired: semanticColors.status.expired,
  payment_error: semanticColors.status.error
};

type StatusProps = {
  status?: PaymentStatus | string | null;
  urlPending?: string | null;
};

export default function Status({ urlPending = null, status }: StatusProps) {
  const { t } = useTranslation();

  // The API may return a transaction with no status at all, so fall back
  // instead of indexing into the map blindly.
  const isKnownStatus = Boolean(status && status in statusColors);
  const color = isKnownStatus
    ? statusColors[status as PaymentStatus]
    : semanticColors.status.expired;
  const label = isKnownStatus
    ? t(`paymentStatus.${status as PaymentStatus}`)
    : t("paymentStatus.unknown");

  return (
    <Chip
      sx={{
        cursor: urlPending ? "pointer" : "unset",
        color: semanticColors.text.inverse,
        ...typography.body.mBold,
        backgroundColor: color,
        borderRadius: "20px",
        height: "24px",
        minWidth: "128px"
      }}
      label={label}
      clickable={false}
      onClick={() => {
        if (!urlPending) return null;
        window.location.assign(urlPending);
      }}
      icon={urlPending ? <ReplayIcon color="inherit" /> : undefined}
    />
  );
}
